<template>
	<div class="checkout-in-place">
		<AppBottomSheet id="checkout-in-place-sheet" :forceWidth="bottomSheetWidth" :active="!!clientSecret" @toggling-popup="togglingPopup" >
			<div v-if="clientSecret" id="stripe-checkout"></div>
		</AppBottomSheet>
	</div>
</template>

<script>
import {useScriptStore} from "@/shared/stores";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";

export default {
	components: {AppBottomSheet},
	setup() {
		let scriptStore = useScriptStore();
		return {scriptStore}
	},
	name: "CheckoutInPlace",
	data() {
		return {
			stripe: null,
			checkout: null,
		}
	},
	props: {
		clientSecret: {type: String, default: null},
	},
	emits: ["toggling-popup", "checkout-complete"],
	mixins: [WindowWidth],
	computed: {
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else if (this.windowWidth < 768) {
				return "550px";
			} else if (this.windowWidth < 1120) {
				return "720px";
			} else {
				return "1080px";
			}
		},
	},
	methods: {
		initCheckout(retry = true) {
			const handleComplete = () => {
				if(this.checkout) {
					this.$emit("checkout-complete");
				}
			}

			this.stripe.initEmbeddedCheckout({
				clientSecret: this.clientSecret,
				onComplete: handleComplete,
			}).then((checkout) => {
				this.checkout = checkout;
				checkout.mount('#stripe-checkout');
			}).catch((err) => {
				console.error(err);
				if(this.checkout) {
					this.checkout.destroy();
					this.checkout = null;
					if(retry) {
						this.initCheckout(false);
					}
				}
			});
		},
		togglingPopup(v) {
			this.$emit("toggling-popup", v);
		}
	},
	mounted() {
		if(this.clientSecret) {
			this.scriptStore.loadScript("stripe", () => {
				this.stripe = Stripe(STRIPE_PUBLIC_KEY_2);
				this.initCheckout();
			});
		}
	},
	unmounted() {
		if(this.checkout) {
			this.checkout.destroy();
			this.checkout = null;
		}
	},
	watch: {
		clientSecret() {
			if(this.clientSecret) {
				this.scriptStore.loadScript("stripe", () => {
					this.stripe = Stripe(STRIPE_PUBLIC_KEY_2);
					this.initCheckout();
				});
			} else {
				if(this.checkout) {
					this.checkout.destroy();
					this.checkout = null;
				}
			}
		}
	}
}
</script>

<style lang="scss">
#checkout-in-place-sheet {

	.bottom-sheet {
		padding: 0;
		border-radius: 13px 13px 0 0;

		.bottom-sheet-measurer {
			border-radius: 13px 13px 0 0;
		}
	}
}
</style>
<style scoped lang="scss">

</style>